import { blobToBase64 } from "@9amhealth/shared";

declare global {
  interface Window {
    flutter_inappwebview?: {
      callHandler: (handlerName: string, ...args: unknown[]) => Promise<string>;
    };
  }
}

const HANDLER_NAME = "onFileData";

export const isFlutterInAppWebView = (): boolean =>
  Boolean(window.flutter_inappwebview);

function getChunkSize(base64Length: number): number {
  const sizeInMB = (base64Length * 2) / (1024 * 1024);

  if (sizeInMB < 1) return 512 * 1024;
  if (sizeInMB < 5) return 256 * 1024;
  if (sizeInMB < 15) return 128 * 1024;
  return 64 * 1024;
}

async function sendChunked(
  filename: string,
  base64String: string
): Promise<boolean> {
  const webview = window.flutter_inappwebview;
  if (!webview) return false;

  const chunkSize = getChunkSize(base64String.length);
  const totalChunks = Math.ceil(base64String.length / chunkSize);

  await webview.callHandler(HANDLER_NAME, {
    type: "start",
    filename,
    totalChunks,
    totalLength: base64String.length
  });

  for (let i = 0; i < totalChunks; i++) {
    const chunk = base64String.substring(i * chunkSize, (i + 1) * chunkSize);

    const ack = await webview.callHandler(HANDLER_NAME, {
      type: "chunk",
      index: i,
      data: chunk
    });

    if (ack !== "ok") throw new Error(`Chunk ${i} failed: ${ack}`);
  }

  const result = await webview.callHandler(HANDLER_NAME, {
    type: "end"
  });

  return result === "ok";
}

export async function sendFileToFlutterApp(
  blob: Blob,
  filename: string
): Promise<boolean> {
  if (!window.flutter_inappwebview) return false;

  const base64String = await blobToBase64(blob);
  return sendChunked(filename, base64String);
}
